"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const common_1 = require("@Const/common");
require("./index.scss");
const NavBarWrapper = ({ wrapperClass, accountingBlock, rightBlock, burgerBlock, children, }) => (react_1.default.createElement("nav", { className: (0, clsx_1.default)('navigation-bar-component', wrapperClass), "data-testid": "navigation-bar-component" },
    react_1.default.createElement("div", { className: `accounting-block` },
        react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.home.root(), className: "logo-link" },
            react_1.default.createElement("img", { src: common_1.ICONS.mlc_logo_black, alt: "MLC Logo" })),
        accountingBlock),
    children,
    react_1.default.createElement("div", { className: "right-block" }, rightBlock),
    burgerBlock));
exports.default = NavBarWrapper;
